import React, { useCallback, useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useSelector } from "react-redux";
import { Box, Container, Grid, Skeleton, Card, Typography } from "@mui/material";
import HeaderBanner from "../../../assets/others/all-category-banner.webp";
import MaxDiscount from "../MAXDISCOUNT"
import { Helmet } from 'react-helmet-async';
import ProductCard from "../../../components/card/ProductCard";
import { useLocation, useNavigate } from "react-router-dom";
import ProductBanner from "../LARGEDEVICE/ProductsBanner";

const categoryUrl = (title) => {
    const url = title?.toLowerCase().replace(/\s+/g, "-");
    return url?.replace(/[^a-z0-9-]/g, "");
};

const Index = () => {
    const [value, setValue] = useState(0);
    const searchItem = useLocation();
    const allCategory = useSelector((state) => state.Category.allData);
    const allProducts = useSelector((state) => state.AllProducts.allData);
    const canonicalUrl = `https://www.99gift.in/${searchItem.pathname}`;

    const navigate = useNavigate();
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const categoryParam = searchParams.get('category');

    useEffect(() => {
        if (categoryParam) {
            const selectedCategoryIndex = allCategory.findIndex(
                (item) => categoryUrl(item.title) === categoryParam
            );
            if (selectedCategoryIndex !== -1 && selectedCategoryIndex !== value) {
                setValue(selectedCategoryIndex);
            }
        }
    }, [categoryParam, allCategory, value]);

    const handleChange = useCallback((event, newValue) => {
        setValue(newValue);
        const selectedCategory = allCategory[newValue]?.title;
        const categorySlug = categoryUrl(selectedCategory);

        if (categorySlug !== categoryParam) {
            navigate(`/card-list?category=${categorySlug}`);
        }
    }, [allCategory, categoryParam, navigate]);

    return (
        <React.Fragment>
            <Helmet>
                <title>Get All Gift Cards</title>
                <meta name="description" content="Get All Gift Cards" />
                <meta property="og:url" content={canonicalUrl} />
                <meta property="og:title" content="Get All Gift Cards" />
                <meta property="og:description" content="Get All Gift Cards" />
                <link rel="canonical" href={canonicalUrl} /> {/* Dynamic Canonical URL */}
            </Helmet>
            <Container maxWidth="false" sx={{ px: "0 !important" }}>
                <Box sx={{
                    objectFit: "cover",
                    minHeight: {
                        xs: "130px",
                        sm: "130px",
                        md: "130px",
                        lg: "216px"
                    },
                    display: "flex",
                    justifyContent: "center"
                }}>
                    <img src={HeaderBanner} alt="Header Banner" style={{ objectFit: "contain", width: "100%", height: "100%" }} />
                </Box>
            </Container>

            <Grid container sx={{
                mt: 3,
            }}>
                <MaxDiscount />
            </Grid>


            <Grid container sx={{
                mb: {
                    sm: 3,
                    lg: 0
                }
            }}>
                <ProductBanner />
            </Grid>


            <Container maxWidth="false" sx={{ mb: 4, backgroundColor: "white.main" }}>
                <Box sx={{ width: "100%" }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value}
                            onChange={handleChange}
                            aria-label="all category tabs"
                            variant="scrollable"
                            scrollButtons="auto">

                            {allCategory?.map((item) =>
                                item?.products?.length &&
                                (
                                    <Tab key={item?.id}
                                        label={item?.title}
                                        {...a11yProps(item?.id)}
                                        sx={{
                                            fontSize: "10px",
                                            textTransform: "capitalize",
                                            pb: 0,
                                            pt: 0,
                                        }}
                                    />
                                )
                            )}
                        </Tabs>
                    </Box>

                    {allCategory.map((item, index) => (
                        (<CustomTabPanel key={`99gift-category-md-id${item.id}`} value={value} index={index}>
                            {filterData(item.id).length > 0 ? filterData(item.id)?.map((product) =>
                                <ProductCard
                                    key={product.id}
                                    customStyles={customStyles}
                                    data={product} />
                            )
                                : <NotFoundProduct />}

                        </CustomTabPanel>)
                    ))}
                </Box>
            </Container>
        </React.Fragment>
    );


    function NotFoundProduct() {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "40vh",
                    width: "95%",
                    position: "absolute",
                    backgroundColor: "#00000033",
                    borderRadius: 3,
                    boxShadow: 2
                }}
            >
                <Typography
                    variant="body1"
                    sx={{
                        textTransform: "capitalize",
                        textAlign: "center",
                        fontSize: "2.4rem",
                        color: "primary.main",
                    }}
                >
                    ! No Products found in this category
                </Typography>
            </Box>
        );
    }

    function filterData(categoryId) {
        return allProducts?.filter(product => product?.category?.id === categoryId);
    }


    function a11yProps(index) {
        return {
            id: `giftcardcategory-tab-${index}`,
            'aria-controls': `giftcardcategory-tabpanel-${index}`,
        };
    }

    function CustomTabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`giftcardcategory-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
                style={{ minHeight: "40vh", overflow: "hidden" }}
            >
                {value === index && (
                    <Box sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            sm: "repeat(auto-fill, minmax(165px, 165px))",
                            md: "repeat(auto-fill, minmax(175px, 175px))",
                        },
                        justifyContent: "space-evenly",
                        columnGap: 3,
                        rowGap: 2,
                        py: {
                            sm: 3,
                            md: 3
                        }
                    }}>
                        {children}
                    </Box>
                )}
            </div>
        );
    }



}

const customStyles = {
    minWidth: {
        sm: "100%",
        md: "130px",
    },
    maxWidth: {
        sm: "100%",
        md: "180px",
    },
    height: {
        sm: 198,
        md: "210px",
    },
    maxHeight: {
        sm: 198,
        md: "247px",
    },
    borderRadius: {
        xs: 6,
        sm: 4,
        lg: 5
    },
    boxShadow: {
        xs: 2,
        sm: 2,
        lg: 2
    },
    border: {
        xs: 0,
        sm: "3px solid #deebff"
    },
    p: { xl: "0 0 5px 0" },
    mx: { xs: "3px", sm: "3px" },
    my: {
        xs: "5px",
        sm: "3px",
        lg: "5px",
    },
    mb: {
        xs: "10px",
        sm: "3px",
        lg: "5px",
    },
    "&:hover": {
        boxShadow: {
            sm: 3,
        },
        border: {
            xs: 0,
            sm: "3px solid #deebff"
        }
    },
    cardMedia: {
        p: 0,
        width: "100%",
        minHeight: { sm: 115, md: 120 },
        maxHeight: { sm: 115, md: 130 },
        borderRadius: "0 0 10px 10px",
        objectFit: {
            xs: "fill",
            sm: "cover",
            md: "contain",
            lg: "cover"
        },
        backgroundSize: {
            xs: "fill",
            sm: "cover",
            md: "contain",
            lg: "cover"
        },
        objectPosition: "50% 50%",
        mixBlendMode: "multiply"
    },
    ".product__discount": {
        backgroundRepeat: "no-repeat",
        objectFit: "cover",
        width: "100%"
    },
    boughtUser: {
        fontSize: {
            xs: "10px",
            lg: "10px"
        },
        color: {
            xs: "textPrimary.main",
            lg: "textPrimary.main"
        },
        fontWeight: {
            xs: 400,
            lg: 400
        },
        display: {
            xs: "none",
            sm: "none"
        }
    },
    cardContent: {
        mt: "16px",
        py: { xs: 0 },
        px: {
            xs: "10px",
            sm: "15px"
        },
        height: {
            xs: "max-content",
            sm: "80px",
            md: "80px",
            lg: "65px",
        },
        overFlow: "hidden",
        webkitBoxOrient: "horizontal",
        webkitLineClamp: 2,
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        textAlign: {
            xs: "center",
            sm: "left",
            lg: "center"
        },
        mb: "5px",
    },
    title: {
        color: {
            sm: "primary.main",
        },
        fontSize: {
            sm: "13.5px",
            md: "1.2rem",
        },
        fontWeight: { sm: 400, lg: 500, xl: 500 },
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        webkitLineClamp: 2,
        maxHeight: "3.6rem",
        lineHeight: { xs: "24px", md: "22px" },
        overflowWrap: "break-word",
        wordBreak: "normal",
        textAlign: "center"
    },
    button: {
        width: "100%",
        fontSize: {
            xs: "9px",
            sm: "10px",
            lg: "12px"
        },
        color: {
            xs: "white.main",
            sm: "white.main",
        },
        backgroundColor: {
            xs: "primary.main",
            sm: "primary.main",
        },
        textTransform: {
            xs: "capitalize"
        },
        borderRadius: {
            xs: 5,
            sm: 5,
            lg: 1
        }
    },
    cardActions: {
        px: 2,
        display: "none",
        flexDirection: "column",
        alignItems: "flex-start",
        py: 0,
    }
}

export default Index;